import { render, staticRenderFns } from "./CreateStudentAccount.vue?vue&type=template&id=5ef606d0&"
import script from "./CreateStudentAccount.vue?vue&type=script&lang=js&"
export * from "./CreateStudentAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateStudentAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports